import { defineMessages } from 'react-intl';

/** The copy of Find and the target drawer (design outreach c1 to c3, m3). */
export const findMessages = defineMessages({
  rowNoContact: { id: 'app.outreach.find.noContact', defaultMessage: 'No contact found yet' },
  title: { id: 'app.outreach.find.title', defaultMessage: 'Who fits {song}' },
  titleNoSong: { id: 'app.outreach.find.titleNoSong', defaultMessage: 'Who fits you' },
  crumb: { id: 'app.outreach.find.crumb', defaultMessage: 'Find' },
  intro: {
    id: 'app.outreach.find.intro',
    defaultMessage:
      'Ranked by the artists like you that they add, their size and their growth. Bought and inactive playlists are hidden.',
  },
  songLabel: { id: 'app.outreach.find.song', defaultMessage: 'Release' },
  anySong: { id: 'app.outreach.find.anySong', defaultMessage: 'All my songs' },

  filterEmail: { id: 'app.outreach.find.filter.email', defaultMessage: 'Has email' },
  filterFlagged: { id: 'app.outreach.find.filter.flagged', defaultMessage: 'Show bought and inactive' },
  filterFollowers: { id: 'app.outreach.find.filter.followers', defaultMessage: 'Followers' },
  followersAny: { id: 'app.outreach.find.filter.followers.any', defaultMessage: 'Any size' },
  followersSmall: { id: 'app.outreach.find.filter.followers.small', defaultMessage: 'Under 1k' },
  followersMid: { id: 'app.outreach.find.filter.followers.mid', defaultMessage: '1k – 60k' },
  followersBig: { id: 'app.outreach.find.filter.followers.big', defaultMessage: 'Over 60k' },
  filterCountry: { id: 'app.outreach.find.filter.country', defaultMessage: 'Country (2 letters)' },
  filterSearch: { id: 'app.outreach.find.filter.search', defaultMessage: 'Search a name' },
  resultCount: { id: 'app.outreach.find.count', defaultMessage: '{shown} of {total} · sorted by fit' },
  cappedNote: {
    id: 'app.outreach.find.capped',
    defaultMessage: 'On Free you see the top {count} of each kind. A paid plan shows all of them.',
  },

  colTarget: { id: 'app.outreach.find.col.target', defaultMessage: 'Name' },
  colFollowers: { id: 'app.outreach.find.col.followers', defaultMessage: 'Followers' },
  colWhy: { id: 'app.outreach.find.col.why', defaultMessage: 'Why it fits' },
  colContact: { id: 'app.outreach.find.col.contact', defaultMessage: 'Contact' },
  colFit: { id: 'app.outreach.find.col.fit', defaultMessage: 'Fit' },

  flagLooksBought: { id: 'app.outreach.find.flag.looksBought', defaultMessage: 'Looks bought' },
  flagStale: { id: 'app.outreach.find.flag.stale', defaultMessage: 'No new song in 90 days' },
  flagEditorial: { id: 'app.outreach.find.flag.editorial', defaultMessage: 'Editorial' },
  flagFatigue: { id: 'app.outreach.find.flag.fatigue', defaultMessage: 'Week limit · free again {date}' },
  inWorkspace: { id: 'app.outreach.find.inWorkspace', defaultMessage: 'In your contacts' },

  empty: { id: 'app.outreach.find.empty', defaultMessage: 'Plug found nothing of this kind yet.' },
  emptyBody: {
    id: 'app.outreach.find.emptyBody',
    defaultMessage: 'Plug looks again after each change of your sound. Paste a link to add one you know.',
  },
  addByUrl: { id: 'app.outreach.find.addByUrl', defaultMessage: 'Add by link' },
  addByUrlPlaceholder: {
    id: 'app.outreach.find.addByUrl.placeholder',
    defaultMessage: 'Paste a playlist, blog or channel link',
  },
  addByUrlDone: { id: 'app.outreach.find.addByUrl.done', defaultMessage: 'Added. Plug reads the page for a contact.' },
  addByUrlFailed: {
    id: 'app.outreach.find.addByUrl.failed',
    defaultMessage: 'We could not add this link. Check it and try again.',
  },

  // c2 drawer
  drawerBy: { id: 'app.outreach.drawer.by', defaultMessage: '{kind} · by {name}' },
  drawerFollowers: { id: 'app.outreach.drawer.followers', defaultMessage: 'Followers' },
  drawerCountry: { id: 'app.outreach.drawer.country', defaultMessage: 'Country' },
  drawerFit: { id: 'app.outreach.drawer.fit', defaultMessage: 'Fit' },
  similarOnIt: { id: 'app.outreach.drawer.similarOnIt', defaultMessage: 'Artists like you on it' },
  contactTitle: { id: 'app.outreach.drawer.contact', defaultMessage: 'Contact' },
  noContact: {
    id: 'app.outreach.drawer.noContact',
    defaultMessage: 'No published contact yet. Plug keeps looking on their public pages.',
  },
  rulesTitle: { id: 'app.outreach.drawer.rules', defaultMessage: 'Their rules' },
  rulesNoGenres: { id: 'app.outreach.drawer.rules.noGenres', defaultMessage: 'No {genres}' },
  rulesViaForm: { id: 'app.outreach.drawer.rules.viaForm', defaultMessage: 'Submissions through their form only' },
  historyTitle: { id: 'app.outreach.drawer.history', defaultMessage: 'History' },
  historyNone: { id: 'app.outreach.drawer.history.none', defaultMessage: 'Your workspace: not pitched before' },
  historyRow: { id: 'app.outreach.drawer.history.row', defaultMessage: '{campaign} · {date}' },
  networkRule: {
    id: 'app.outreach.drawer.networkRule',
    defaultMessage: 'Your workspace sends a person at most {cap} pitches a week.',
  },
  pitchTo: { id: 'app.outreach.drawer.pitchTo', defaultMessage: 'Pitch {song} to {name}' },
  pitchToNoSong: { id: 'app.outreach.drawer.pitchToNoSong', defaultMessage: 'Pitch {name}' },
  revealed: { id: 'app.outreach.drawer.revealed', defaultMessage: 'Revealed' },
  bounced: { id: 'app.outreach.drawer.bounced', defaultMessage: 'This address bounced' },

  // m3 the Spotify for Artists helper
  editorialTitle: {
    id: 'app.outreach.drawer.editorial.title',
    defaultMessage: 'Spotify picks editorial songs only through Spotify for Artists',
  },
  editorialBody: {
    id: 'app.outreach.drawer.editorial.body',
    defaultMessage:
      'There is no email for editorial playlists. Pitch an unreleased song at least 7 days before release.',
  },
  writeS4a: { id: 'app.outreach.s4a.write', defaultMessage: 'Write my Spotify for Artists pitch' },
  s4aTitle: { id: 'app.outreach.s4a.title', defaultMessage: "Pitch {song} to Spotify's editors" },
  s4aBody: {
    id: 'app.outreach.s4a.body',
    defaultMessage:
      'Spotify picks editorial songs only through Spotify for Artists, at least 7 days before release. Paste this there.',
  },
  s4aPitchLabel: { id: 'app.outreach.s4a.pitchLabel', defaultMessage: 'Pitch (500 characters)' },
  s4aCount: { id: 'app.outreach.s4a.count', defaultMessage: '{count} / 500' },
  s4aGenres: { id: 'app.outreach.s4a.genres', defaultMessage: 'Genres: {list}' },
  s4aMoods: { id: 'app.outreach.s4a.moods', defaultMessage: 'Moods: {list}' },
  s4aInstruments: { id: 'app.outreach.s4a.instruments', defaultMessage: 'Instruments: {list}' },
  s4aCulture: { id: 'app.outreach.s4a.culture', defaultMessage: 'Culture: {list}' },
  s4aOpen: { id: 'app.outreach.s4a.open', defaultMessage: 'Open Spotify for Artists' },
  s4aCopy: { id: 'app.outreach.s4a.copy', defaultMessage: 'Copy the pitch' },
  s4aNoApi: {
    id: 'app.outreach.s4a.noApi',
    defaultMessage: 'There is no way to send it for you: Spotify has no pitch API.',
  },
  s4aReleased: { id: 'app.outreach.s4a.released', defaultMessage: 'Editorial pitches are only for unreleased songs.' },
  s4aPickSong: { id: 'app.outreach.s4a.pickSong', defaultMessage: 'Pick a release at the top of Find first.' },
  s4aFailed: { id: 'app.outreach.s4a.failed', defaultMessage: 'Plug could not write the pitch. Try again.' },
  s4aMarkPitched: { id: 'app.outreach.s4a.markPitched', defaultMessage: 'I pitched it' },
  s4aMarkHint: {
    id: 'app.outreach.s4a.markHint',
    defaultMessage: 'Mark it when you sent the pitch in Spotify for Artists. Then the reminders stop.',
  },
  s4aPitchedOn: { id: 'app.outreach.s4a.pitchedOn', defaultMessage: 'Pitched on {date}' },
  s4aUndo: { id: 'app.outreach.s4a.undo', defaultMessage: 'Undo' },
  s4aDeadline: { id: 'app.outreach.s4a.deadline', defaultMessage: 'Spotify takes the pitch until {date}.' },
  s4aMarkFailed: { id: 'app.outreach.s4a.markFailed', defaultMessage: 'MUSIC24 could not save the mark. Try again.' },
  pitchIntoDraftFailed: {
    id: 'app.outreach.find.pitchIntoDraftFailed',
    defaultMessage: 'We could not add them to the campaign. Try again.',
  },
});
